import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Globe } from "lucide-react";
import { GoldMark } from "@/components/common";
import { ConnectWalletButton } from "@/components/ConnectWalletButton";
import { useLang } from "@/i18n";

const LINKS = [
  { to: "/", key: "nav.home" },
  { to: "/about", key: "nav.about" },
  { to: "/tokenomics", key: "nav.tokenomics" },
  { to: "/nfts", key: "nav.nfts" },
  { to: "/mint", key: "nav.mint" },
  { to: "/ecosystem", key: "nav.ecosystem" },
  { to: "/roadmap", key: "nav.roadmap" },
  { to: "/whitepaper", key: "nav.whitepaper" },
  { to: "/transparency", key: "nav.transparency" },
];

export function Header() {
  const { t, lang, toggle } = useLang();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="glass-header fixed inset-x-0 top-0 z-50" data-testid="site-header">
      <div className="section-pad flex h-16 items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link" onClick={() => setOpen(false)}>
          <GoldMark size={32} />
          <span className="font-display text-lg uppercase tracking-wide text-paper">
            Maga<span className="gold-text">Brazil</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-5 xl:flex" aria-label="Main">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.key.split(".")[1]}`}
              className={({ isActive }) =>
                `font-heading text-[11px] font-semibold uppercase tracking-[0.18em] transition-colors ${
                  isActive ? "text-neon" : "text-mist hover:text-paper"
                }`
              }
            >
              {t(l.key)}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <button
            type="button"
            onClick={toggle}
            data-testid="lang-toggle"
            className="mono-chip border-white/15 transition-colors hover:border-neon/50 hover:text-neon"
            aria-label="Switch language"
          >
            <Globe size={12} />
            {lang === "en" ? "PT" : "EN"}
          </button>
          <div className="hidden sm:block">
            <ConnectWalletButton compact />
          </div>
          <button
            type="button"
            className="mono-chip border-white/15 xl:hidden"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-btn"
            aria-label="Menu"
          >
            {open ? <X size={14} /> : <Menu size={14} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-ink/95 px-6 py-6 backdrop-blur-xl xl:hidden" data-testid="mobile-menu">
          <nav className="flex flex-col gap-4" aria-label="Mobile">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mnav-${l.key.split(".")[1]}`}
                className={({ isActive }) =>
                  `font-heading text-sm font-bold uppercase tracking-[0.2em] ${isActive ? "text-neon" : "text-paper"}`
                }
              >
                {t(l.key)}
              </NavLink>
            ))}
            <div className="pt-3 sm:hidden">
              <ConnectWalletButton />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
